import { authHeader } from '../helpers/authHeader';
import { handleAxiosResponse, api_base_url, axiosInstance } from '../services/common.services';
import { handleServiceRequest } from '../services/handleServiceRequest';
import NotificationService from './NotificationService';
import {forEach} from 'react-bootstrap/ElementChildren';
import {CustomerSearchType} from "../components/customer-management/CustomerSearchForm";
import notificationService from "./NotificationService";
import {toUTCISOString} from "../shared/sharedFunctions";

export const publicCustomerService = {
    makeEstimateRequest,
    getPublicCustomerUniqueId,
    findByCustomerNumber,
    uploadPaymentMethod,
    getCustomerInfo,
    getAvailableDates,
    verifyForPayment,
    makePayment,
    scheduleJob(webIdUniqueToken: string, jobId: number, scheduledDate: any, webComments: any) {
        const object = {
            url: `${baseUrl}/${webIdUniqueToken}/current-job/schedule/${jobId}`,
            postBody: {
                requestedDate: scheduledDate,
                webComments: webComments
            },
        };
        return handleServiceRequest.post(object);
    }
};
const baseUrl = `/api/public/customers`;

function makeEstimateRequest(data: any) {
    const object = {
        url: `${baseUrl}/quote-requests`,
        postBody: data,
        customErrorMessage: `Failed to make estimate request. Please try again later`,
    };
    return handleServiceRequest.post(object);
}

function getPublicCustomerUniqueIdErrorHandler(error): void {
    const status = error.response?.status || error.status;
    if (status === 404) {
        NotificationService.error("User with that WebId not found");
    } else {
        NotificationService.handleError(error);
    }
}

function getPublicCustomerUniqueId(customerWebId) {
    const object = {
        url: `${baseUrl}/find`,
        postBody: {
            webId: customerWebId
        },
        customHandleError: getPublicCustomerUniqueIdErrorHandler
    };
    return handleServiceRequest.post(object);
}

function getCustomerInfo(customerWebId) {
    const object = {
        url: `${baseUrl}/${customerWebId}/current-job/estimate`,
        customErrorMessage: `Failed to load your information. Please try again later`,
    };
    return handleServiceRequest.get(object);
}

function uploadPaymentMethod(customerUniqueId, data) {
    const object = {
        url: `${baseUrl}/${customerUniqueId}/payment-methods`,
        customErrorMessage: `Failed to upload your payment information. Please try again later`,
        postBody: data
    };
    return handleServiceRequest.post(object);
}

function getAvailableDates(customerWebId, jobId) {
    const object = {
        url: `${baseUrl}/${customerWebId}/current-job/available-dates/${jobId}`,
        customErrorMessage: `Failed to get any dates for this job. Please try again later`,
    };
    return handleServiceRequest.get(object);
}

function verifyForPayment(customerNumber: number, streetNumber: string, streetName: string, postalCode: string) {
    const object = {
        url: `${baseUrl}/verify-for-payment`,
        postBody: { customerNumber, streetNumber, streetName, postalCode },
        customHandleError: (error) => {
            const status = error.response?.status || error.status;
            if (status === 404) {
                return null;
            }
            NotificationService.handleError(error);
        }
    };
    return handleServiceRequest.post(object);
}

function findByCustomerNumber(customerNumber: number, streetNumber: string, streetName: string, postalCode: string) {
    const object = {
        url: `${baseUrl}/find-by-customer-number`,
        postBody: { customerNumber, streetNumber, streetName, postalCode },
        customHandleError: (error) => {
            const status = error.response?.status || error.status;
            if (status !== 404) NotificationService.handleError(error);
        }
    };
    return handleServiceRequest.post(object);
}

function makePayment(data: any) {
    const object = {
        url: `${baseUrl}/make-payment`,
        postBody: data,
        customErrorMessage: `Failed to process payment. Please try again later`,
    };
    return handleServiceRequest.post(object);
}
